// The package root is found by walking up from this module rather than by a
// fixed number of `..` steps. The shipped CLI is one bundled file in `dist/`,
// while `tsc`'s per-file output nests modules under `dist/<area>/`, so a fixed
// count is only ever right for one of the two layouts.
import * as fs from "node:fs";
import * as path from "node:path";
import { fileURLToPath } from "node:url";

const NAME = "@lingjingai/scriptctl";
let cached = "";

export function packageRoot(): string {
  if (cached) return cached;
  let cursor = path.dirname(fileURLToPath(import.meta.url));
  for (;;) {
    try {
      const raw = fs.readFileSync(path.join(cursor, "package.json"), "utf-8");
      if ((JSON.parse(raw) as { name?: string }).name === NAME) {
        cached = cursor;
        return cursor;
      }
    } catch {
      // No readable package.json here; keep walking.
    }
    const parent = path.dirname(cursor);
    if (parent === cursor) throw new Error(`${NAME} package root not found`);
    cursor = parent;
  }
}

export function packageVersion(): string {
  const raw = fs.readFileSync(path.join(packageRoot(), "package.json"), "utf-8");
  const version = (JSON.parse(raw) as { version?: unknown }).version;
  if (typeof version !== "string") throw new Error(`${NAME} package.json has no string version`);
  return version;
}
